import styled, { css } from 'styled-components';

const tdFixed = css`
  color: #1F2937;
  padding-left: 15px;
  &:last-child {
    position: sticky;
    right: 0;
  }
`;

const tdBasic = css`
  color: #1F2937;
  padding-left: 15px;
`;

const thFixed = css`
  text-align: left;
  color: #42474F;
  font-weight: bold;
  padding-left: 15px;
  height: 10px;
  line-height: 1;
  &:last-child {
    position: sticky;
    right: 0;
  }
`;

const thBasic = css`
  text-align: left;
  color: #42474F;
  font-weight: bold;
  padding-left: 15px;
  height: 10px;
  line-height: 1;
`;

export const Table = styled.table`
  width: 100%;
  border-radius: "5px";

  tbody tr:last-child {
    border-bottom: none !important;
  }

  tbody tr:last-child td {
    background: #ffffff !important;
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 14px;
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 14px;
  }
`;

export const TableHead = styled.thead`
  height: 40px;
  background: ${({ bg }) => bg || 'none'};
  position: sticky;
  top: 0;
  z-index: 1;
  border-radius: 10;
`;

export const TableBody = styled.tbody``;

export const TableTR = styled.tr`
  background: ${({ bg }) => bg || 'none'};
  height: 40px;
  position: relative;
`;

export const TableTH = styled.th`
  background: ${({ bg }) => bg || 'none'};
  min-width: ${({ minWidth }) => minWidth || 'auto'};
  ${({ fixed }) => (fixed ? thFixed : thBasic)}

  &:first-child {
    border-top-left-radius: 14px;
  }

  &:last-child {
    border-top-right-radius: 14px;
  }
`;

export const TableTD = styled.td`
  background: ${({ bg }) => bg || '#ffffff'};
  ${({ fixed }) => (fixed ? tdFixed : tdBasic)}
`;
